import React from 'react';
import styled from 'styled-components';
import { colors } from '~/styles';
import IconTooltip from '../IconTooltip';

const S = {
  IconContainer: styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 4rem;
  `,
};

export default function OutcomeIcon({ outcome, message }) {
  switch (outcome) {
    case 'succeeded':
      return (
        <S.IconContainer>
          <IconTooltip icon="check-circle" color={colors.success} message="Succeeded." />
        </S.IconContainer>
      );

    case 'failed':
      return (
        <S.IconContainer>
          <IconTooltip icon="exclamation-triangle" color={colors.warning} message={message ? message : 'Failed'} />
        </S.IconContainer>
      );

    case 'skipped':
      return (
        <S.IconContainer>
          <IconTooltip icon="minus-circle" color={colors.grey40} message={message ? message : 'Skipped'} />
        </S.IconContainer>
      );
  }
}
